/**
 * What warehouse staff typed for this item on the OP create form (spec
 * docs/archive/202610/specs_20261019_op-quote-routing.md). Read-only. Usually a suggestion
 * beside the engine's SP and BP; on a price-agreed quote it IS the price, and
 * Prism applies it at every grade (spec docs/specs_20261021_price-agreed-holds.md).
 */
const pounds = (cents) => (cents % 100 === 0 ? String(cents / 100) : (cents / 100).toFixed(2));

/** Whether this item's SP/BP is the final agreed price, so the fields lock. */
export const isAgreedPrice = (deal, item) => !!deal?.price_agreed && item?.warehouse_bp_cents != null;

const pair = (sp, bp) => [sp != null && `SP £${sp}`, bp != null && `BP £${bp}`].filter(Boolean).join(' / ');

/** `engine` is the engine's own {sp, bp} in pounds, shown only beside an agreed price. */
export default function WarehouseSuggestion({ spCents, bpCents, agreed = false, engine = null }) {
    const typed = pair(spCents != null ? pounds(spCents) : null, bpCents != null ? pounds(bpCents) : null);
    if (!typed) return null;
    const label = agreed ? 'Agreed price (final)' : 'Warehouse suggestion';
    const said = agreed && engine ? pair(engine.sp, engine.bp) : '';
    return (
        <>
            <div className="qa-warehouse-suggestion">{`${label}: ${typed}`}</div>
            {said && <div className="qa-warehouse-suggestion">{`Engine said: ${said}`}</div>}
        </>
    );
}
